import { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";

const extractSectorName = (props = {}) =>
  props.name ||
  props.sector ||
  props.postcode ||
  props.label ||
  props.pcd_sector ||
  props.pcd ||
  props.pcd2 ||
  props.pcd_sect ||
  props.pcd_sector_code ||
  "";

export default function useGeoJson(region, toast) {
  const [geoData, setGeoData] = useState(null);
  const [loadingGeo, setLoadingGeo] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const fetchGeoJson = async () => {
      console.log("--------------------------------------------------");
      console.log("[useGeoJson] 🔍 region prop:", region);

      setLoadingGeo(true);
      setGeoData(null);

      const loadAndParse = async (regionCode) => {
        const upper = (regionCode || "PR").toUpperCase();
        const filename = `UK/${upper}.geojson`;

        console.log("[useGeoJson] 🗂 regionCode:", upper);
        console.log("[useGeoJson] 📄 filename:", filename);
        console.log(`[useGeoJson] 📥 Downloading from Supabase: geojson/${filename}`);

        const { data, error } = await supabase.storage
          .from("geojson")
          .download(filename);

        if (error) {
          console.error("[useGeoJson] ❌ Supabase error:", error);
          throw new Error(`Supabase error loading ${filename}: ${error.message}`);
        }

        const text = await data.text();
        const parsed = JSON.parse(text);

        console.log("[useGeoJson] 📦 Parsed type:", parsed.type);
        console.log("[useGeoJson] 📊 Feature count:", parsed.features?.length);

        const sample = parsed.features
          ?.slice(0, 10)
          .map((f) => extractSectorName(f.properties));

        console.log("[useGeoJson] 🏷 Sample names:", sample);

        return parsed;
      };

      try {
        const requestedRegion = (region || "PR").toUpperCase();
        let parsed = await loadAndParse(requestedRegion);

        if (!parsed?.features?.length && requestedRegion !== "PR") {
          console.warn(
            `[useGeoJson] ⚠ No features for ${requestedRegion}, falling back to PR`
          );
          parsed = await loadAndParse("PR");
        }

        if (!isCancelled) {
          setGeoData(parsed);
        }
      } catch (err) {
        console.warn("[useGeoJson] ❌ Failed:", err.message);

        if (!isCancelled) {
          setGeoData(null);
        }

        toast?.({
          title: `Failed to load map data`,
          description: err.message,
          status: "error",
        });
      } finally {
        if (!isCancelled) {
          setLoadingGeo(false);
          console.log("[useGeoJson] ✅ Done loading");
          console.log("--------------------------------------------------");
        }
      }
    };

    fetchGeoJson();

    return () => {
      isCancelled = true;
    };
  }, [region, toast]);

  return { geoData, loadingGeo };
}
